/** @jsxImportSource @emotion/react */
"use client";
import type { TextProps } from "../../../_core/Text/Text.emotion";
import type { CategoryMediumProps } from "../CategoryMedium/CategoryMedium.emotion";
import { CategoryMedium } from "../CategoryMedium/CategoryMedium.emotion";

export type CategoryLargeProps = CategoryMediumProps;

export const CategoryLarge = ({
  maskProps,
  titleProps,
  ...props
}: CategoryLargeProps) => (
  <CategoryMedium
    {...props}
    maskProps={{ size: "m", ...maskProps }}
    titleProps={{ size: "xl", ...titleProps } as TextProps}
  />
);
